import styled from '@emotion/styled';
import { GeneralFormError } from '@ui-components/neo.tax';

export const GeneralFormErrorStyled = styled(GeneralFormError)({
  textAlign: 'left',
});
